import FormattedMessage from 'I18n/components/FormattedMessage';
import ButtonWithEditWarning from './ButtonWithEditWarning';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const FileManagerButton = ({
  isFileManagerLoading,
  fileManagerError,
  onClick,
  editWarningConfig
}) => /*#__PURE__*/_jsx(ButtonWithEditWarning, Object.assign({}, editWarningConfig, {
  disabled: isFileManagerLoading,
  onClick: onClick,
  icon: FileIcon,
  testId: "file-manager-button",
  children: /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "headerButtons.createButton.buttons.fileManagerErrorRetry"
    }),
    placement: "left",
    disabled: !fileManagerError,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "headerButtons.createPanel.buttons.fileManager"
    })
  })
}));
export default FileManagerButton;